module.exports = __webpack_public_path__ + "img/music_022.af8a973d.png";